import React from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { DataProcessingModal } from '@fnol/library/src/components';
import fnolTheme from '@fnol/library/src/themes/fnolTheme';
import LifeApp from './components/LifeApp';

// returns MotorApp (the app entry file) and providers

function App() {
    return (
        <>
            <DataProcessingModal></DataProcessingModal>

            <CssBaseline />
            <ThemeProvider theme={fnolTheme}>
                <LifeApp />
            </ThemeProvider>
        </>
    );
}

export default App;
